import { defineComponent as _defineComponent } from 'vue'

export enum OzBaseButtonHrefMode {
  /** Triggers a page reload */
  Default = 'Default',
  /** `href` is for show only. Handle it using `@click` */
  DisplayOnly = 'DisplayOnly',
  /** Changes current URL. Handle it using `@click` */
  HistoryPushState = 'HistoryPushState',
  /** Opens page in new tab */
  NewTab = 'NewTab',
}

const __default__ = {}

import type { LongPressEvent } from '@@/vuedirectives/emit_long_press'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzBaseButton',
  props: {
    href: { default: undefined },
    disabled: { type: Boolean, default: false },
    hrefMode: { default: OzBaseButtonHrefMode.Default }
  },
  emits: ["click", "mouseenter", "mouseleave", "mousedown", "keydown", "focus", "blur", "contextmenu", "long-press", "touchstart", "touchend", "pointerup", "pointerenter", "pointerleave", "pointerdown", "dblclick", "auxclick"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'click', event: MouseEvent): void
  (name: 'mouseenter', event: MouseEvent): void
  (name: 'mouseleave', event: MouseEvent): void
  (name: 'mousedown', event: MouseEvent): void
  (name: 'keydown', event: KeyboardEvent): void
  (name: 'focus', event: FocusEvent): void
  (name: 'blur', event: FocusEvent): void
  (name: 'contextmenu', event: MouseEvent): void
  (name: 'long-press', event: LongPressEvent): void
  (name: 'touchstart', event: TouchEvent): void
  (name: 'touchend', event: TouchEvent): void
  (name: 'pointerup', event: PointerEvent): void
  (name: 'pointerenter', event: PointerEvent): void
  (name: 'pointerleave', event: PointerEvent): void
  (name: 'pointerdown', event: PointerEvent): void
  (name: 'dblclick', event: MouseEvent): void
  (name: 'auxclick', event: PointerEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { href: string, disabled: boolean, hrefMode: OzBaseButtonHrefMode };

/**
 * @file Provides button functionality, but not styling.
 */


const root = ref<HTMLElement>()



const click = (event: MouseEvent): void => {
  if (props.hrefMode !== OzBaseButtonHrefMode.Default) event.preventDefault()
  if (props.disabled) {
    event.preventDefault()
    return
  }
  if (props.hrefMode === OzBaseButtonHrefMode.HistoryPushState) {
    // Store the url in the history state so you can read it later
    window?.history?.pushState({ url: props.href }, '', props.href)
  }
  if (props.hrefMode === OzBaseButtonHrefMode.NewTab && props.href) {
    window.open(props.href, '_blank')
  }

  emit('click', event)
}

const handleSpaceKey = (event: KeyboardEvent): void => {
  // Anchor elements with roles set to ‘button’ can only be activated with the ‘enter’ key,
  // whereas a button element would be triggered by both ‘space’ and ‘enter’ keys.
  // Adding a space keypress event listener and calling this method should ensure
  // that the element triggers the same event that a click, or pressing the ‘enter’ key
  // would (mouse click event) and execute the default behavior.
  const SPACE_KEYCODE = event.code === 'Space'
  if (props.href && SPACE_KEYCODE) {
    event.preventDefault()
    // Prevent default scrolling behaviour on anchor tags
    const linkButton = root.value as HTMLAnchorElement
    linkButton?.click()
  }
}

return { __sfc: true,OzBaseButtonHrefMode, props, root, emit, click, handleSpaceKey }
}

})